import { lazy, Suspense } from "react";
import CircularLoader from "../custom/circularLoader/circularLoader";

const Main = lazy(() => import("../components/ApplicationForm/applicationFormSuccess/main"));

const ApplicationFormSuccess = () => {
    return (
        <Suspense fallback={<CircularLoader />}>
            <Main />
        </Suspense>
    )
}

export default ApplicationFormSuccess;